//Styles
import Styles from "./Menu.module.scss";
import classnames from "classnames"

interface MenuProps{
    options:any
    isComponent?:boolean;
  }

const Menu = ({options,isComponent=false}:MenuProps) => {
  return (
    <div className={classnames(Styles.container,"glassBackground",isComponent&&Styles.no_bg)}>
        {options.map((option:any,index:number) => {
          return (
            <div key={option.id || option.label || index} className={classnames(Styles.option, index!=options.length-1 && Styles.divider, option.isComponent && Styles.no_bg)} onClick={option.onClick}>{option.component}</div>
          )
        })}
    </div>
  )
}

export default Menu
